namespace RedBullMOBILE360.PushNotifications {
    export interface PushNotificationsPGForm {
        Notificationdate: Serenity.StringEditor;
        Sender: Serenity.StringEditor;
        Status: Serenity.IntegerEditor;
        Excelfilename: Serenity.StringEditor;
        Isexceluploaded: Serenity.IntegerEditor;
    }

    export class PushNotificationsPGForm extends Serenity.PrefixedContext {
        static formKey = 'PushNotifications.PushNotificationsPG';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PushNotificationsPGForm.init)  {
                PushNotificationsPGForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;

                Q.initFormType(PushNotificationsPGForm, [
                    'Notificationdate', w0,
                    'Sender', w0,
                    'Status', w1,
                    'Excelfilename', w0,
                    'Isexceluploaded', w1
                ]);
            }
        }
    }
}
